import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { ColdStart } from '../components/ui/ColdStart';
import { useConsentCheck } from '../hooks/useConsentCheck';
import { IStore } from '../interfaces/StoreTypes';
import url from '../helpers/url';
import { ROUTE_CONSTANT } from '@libs/constants';
import { buildLanguageRoute } from '../utils/languageRouteBuilder';
import { isGuestBrowseProfile, isGuestUser } from '../config/guestMode';
import { getUserInfo } from '../utils/user';

type ColdStartScreenProps = {
    screenName: string;
    screenKey: string;
};

export const ColdStartScreen: React.FC<ColdStartScreenProps> = () => {
    const params = useParams();
    const langPrefix = params['lang'] === 'en' ? 'en' : '';
    const profile = useSelector((store: IStore) => store.profile);
    const { data: consentData, isLoading } = useConsentCheck(profile?.selectedProfile);

    const isGuest = isGuestUser(getUserInfo()) || isGuestBrowseProfile(profile?.selectedProfile);
    if (isGuest) {
        return <Navigate to={buildLanguageRoute('/', langPrefix)} replace />;
    }

    if (isLoading) {
        return <></>;
    }

    if (consentData?.consentNeeded) {
        return (
            <Navigate
                to={url.route(consentData.exitkid ? ROUTE_CONSTANT.EXIT_KID : ROUTE_CONSTANT.CONSENT_MANAGEMENT)}
                replace
            />
        );
    }

    return <ColdStart />;
};

export default ColdStartScreen;
